import type { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { useNavigate, useSearchParams } from '@remix-run/react';

export function SearchText({ sx, path = '/shop' }: { sx?: SxProps; path?: string }) {
  const navigate = useNavigate();
  const [query] = useSearchParams();
  const search = query.get('search');

  return search ? (
    <Box display="flex" alignItems="center" sx={sx}>
      <Typography variant="body2" color="text.secondary" mr={0.5}>
        Showing results for
      </Typography>
      <Chip label={search} size="small" onDelete={() => navigate(path)} />
    </Box>
  ) : null;
}
